import React, { ReactNode } from 'react';

type IProps = {
  title: ReactNode;
};

export const DestinationDetailsTitle = ({ title }: IProps) => {
  return (
    <div
      className={
        'text-lg leading-none [&_li]:relative [&_li]:marker:text-xs [&_li]:marker:text-gray-700 [&_ul]:mt-3 [&_ul]:text-base [&_ul]:text-neutral-600'
      }
    >
      {title}
    </div>
  );
};
